import { isAxiosError } from 'axios';
import { TIMELINE_STREAM_ERROR } from './chatErrors';

const NETWORK_ERROR_RE =
  /failed to fetch|networkerror|load failed|network request failed|network connection was lost/i;

/**
 * Map a failed Evidence request to the QUERY_NETWORK sentinel only for a
 * genuine transport drop (axios ERR_NETWORK, or a fetch-style message such as
 * "Failed to fetch" / "NetworkError" / "Load failed"). `navigator.onLine` is
 * not a signal — Chrome can report offline while the tab is still reaching
 * the API (EVI-2557). Everything else, including axios ECONNABORTED
 * timeouts, returns null so the caller can roll back and surface its own error.
 *
 * Intentionally avoids importing getErrorMessage from timelineEventSource so
 * unit tests that partially mock that module stay stable.
 */
export function resolveEvidenceNetworkFailure(
  error: unknown
): typeof TIMELINE_STREAM_ERROR.QUERY_NETWORK | null {
  // ERR_NETWORK is a genuine transport drop. ECONNABORTED is deliberately
  // excluded: axios also uses it for request timeouts/aborts, which are not
  // connectivity failures.
  if (isAxiosError(error) && !error.response && error.code === 'ERR_NETWORK') {
    return TIMELINE_STREAM_ERROR.QUERY_NETWORK;
  }

  if (error instanceof Error && NETWORK_ERROR_RE.test(error.message)) {
    return TIMELINE_STREAM_ERROR.QUERY_NETWORK;
  }

  return null;
}
